<template>
  <nav>
    <div v-if="surveyOverview">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p class="text-subtitle-1 no-break font-weight-bold" v-html="question.question"></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="text-center">
        <v-col cols="12" class="mx-auto">
          <v-rating
            :length="question.allowed_options"
            align="center"
            class="survey-rating"
            readonly
            data-testid="rating-numbers"
          >
            <template v-slot:item="props">
              <v-icon
                :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
                :color="props.isFilled ? 'accent' : ''"
                v-text="`mdi-numeric-${props.index + 1}`"
                @click="props.click"
                large
              ></v-icon>
            </template>
          </v-rating>
          <div
            v-for="option in question.allowed_options"
            :key="option"
            class="d-inline-block star"
          >
            <div
              v-if="
                question.stats &&
                question.stats.hasOwnProperty(option) &&
                question.stats[option]
              "
            >
              <span
                >{{
                  calculatePercentage(question.stats[option], numbSubmissions)
                }}%</span
              >
            </div>
            <div v-else>
              <span>0%</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="user">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p
            class="text-subtitle-1 no-break font-weight-bold"
            v-html="question.question"
          ></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="mx-auto">
          <v-rating
            v-if="user[question.qid] && user[question.qid].answer.rating"
            :length="question.allowed_options"
            align="center"
            class="survey-rating"
            readonly
            data-testid="rating-numbers"
            :value="user[question.qid].answer.rating"
          >
            <template v-slot:item="props">
              <v-icon
                :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
                :color="props.isFilled ? 'accent' : ''"
                v-text="`mdi-numeric-${props.index + 1}`"
                @click="props.click"
                large
              ></v-icon>
            </template>
          </v-rating>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-rating
        :value=0
        :length="question.allowed_options"
        align="center"
        class="survey-rating"
        readonly
        data-testid="rating-numbers"
      >
        <template v-slot:item="props">
          <v-icon
            :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
            :color="props.isFilled ? 'accent' : ''"
            v-text="`mdi-numeric-${props.index + 1}`"
            @click="props.click"
            large
          ></v-icon>
        </template>
      </v-rating>
    </div>
  </nav>
</template>
<script>
import { repeatedMethodsMixin } from "../../../mixins/repeatedMethodsMixin";

export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    surveyOverview: {
      type: Boolean,
      default: false,
    },
    numbSubmissions: {
      type: Number,
      default: 0,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [repeatedMethodsMixin],
};
</script>
